import { CommonModule, DOCUMENT,isPlatformBrowser,Location } from '@angular/common';
import { Component, Inject, PLATFORM_ID, Renderer2 } from '@angular/core';
import { SafeHtml, DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { HttpService } from '../../../services/http.service';
import { MetaMgmtService } from '../../../services/meta-mgmt.service';
import { SchemaService } from '../../../services/schema.service';
import { UtilsService } from '../../../services/utils.service';
import { FormsModule } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ShareProductModalComponent } from '../../share-product-modal/share-product-modal.component';
import { SafehtmlPipe } from '../../../pipes/safehtml.pipe';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-blog-detail',
  standalone: true,
  imports: [CommonModule, FormsModule, SafehtmlPipe],
  templateUrl: './blog-detail.component.html',
  styleUrl: './blog-detail.component.scss'
})
export class BlogDetailComponent {
  environment: any = environment;
  blogID: any;
  blogData: any;
  url: any;
  sub:Subscription=new Subscription()
  featureImg: any;
  script:any;
  actualSchemaValue:any;
  scrollPosition = 0;
  structuredData!: SafeHtml;
  constructor(public utils: UtilsService, private httpSvc: HttpService,
    private route: ActivatedRoute, private schemaService: SchemaService,
    private _renderer2: Renderer2,
    public dialog: MatDialog,
    private router: Router, private location: Location,
    private metaSvc: MetaMgmtService,
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(DOCUMENT) private _document: Document,
    private sanitizer: DomSanitizer,
  ) {
    this.utils.showHeaderFooter.next(true);
  }
  ngOnInit(): void {
    if(isPlatformBrowser(this.platformId)) {
      this.scrollPosition = window.scrollY;
    }
    this.sub.add(this.route.params.subscribe((params: any) => {
      this.blogID = params['blogId'];
    }))
    if (this.blogID) {
      this.utils.showLoading();
      this.sub.add(  this.httpSvc.getBlogData(this.blogID).subscribe({
        next: (value: any) => {
          
          if (value && value.success) {
            this.featureImg = value.wordPressPostDetailsResponse.image;
            let updatedData = this.filterAndRemoveNofollow(value.wordPressPostDetailsResponse?.postDescription);
            
            this.blogData = {
                ...value.wordPressPostDetailsResponse,
                postDescription: updatedData
            };
            let metaData: any = {
              description: this.blogData?.postDesc_tag,
              pageTitle: this.blogData?.postTitle_tag,
              keywords: this.blogData?.post_Keyword,
              canonicalURL: environment?.baseApiURl + this.router.url || '',
            }
            this.metaSvc.updateMetaTags(metaData);
            this.getBlogSchema(this.blogData);
            this.url = `${this.utils.baseUrl}blog/post/${this.utils.createNameForUrl(this.blogData.postTitle)}/${this.blogID}`
          }
          this.utils.hideLoading();
        },
        complete:()=>{
        this.callSchema();
        }
      }))
    }
    else {
      this.utils.backToRoot();
    }
  }

  filterAndRemoveNofollow(htmlData: string): string {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlData, 'text/html');
    const links = doc.querySelectorAll('a');
  
    links.forEach(link => {
      let rel = link.getAttribute('rel');
      
      if (rel) {
        const newRel = rel.split(' ')
          .filter(attr => attr !== 'nofollow')
          .join(' ');
  
        link.setAttribute('rel', newRel ? `${newRel} noreferrer noopener` : 'noreferrer noopener');
      } else {
        link.setAttribute('rel', 'noreferrer noopener');
      }
    });
        
    return doc.body.innerHTML;
  }
  
  async callSchema(){
    this.actualSchemaValue = await this.schemaService.addSchema();
    const jsonString = JSON.stringify(this.actualSchemaValue);
    const safeJson = this.sanitizer.bypassSecurityTrustHtml(jsonString);
    this.script  = this._renderer2.createElement('script');
    this.script.type = `application/ld+json`;
    this.script.text = safeJson as string;
    // this.script.text = JSON.stringify(this.actualSchemaValue);
    this._renderer2.appendChild(this._document.body, this.script);
  }

  getBlogSchema(data: any) {
    const BreadcrumbList: any = [];
    // if (isPlatformBrowser(this.platformId)) {
      // data?.forEach((item: any) => {

      // let mainEntityObj = {
      //   "@type": "WebPage",
      //   "@id": `https://www.luminousindia.com${this.url}`
      // }
      let blogItem = {
        "@context": "https://schema.org",
        "@type": 'BlogPosting',
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": `https://www.luminousindia.com${this.router.url}`
        },
        "headline": data?.postTitle,
        "description": data.postDesc_tag,
        "image": data?.image,
        "author": {
          "@type": "Organization",
          "name": "Luminous",
          "url": `https://www.luminousindia.com${this.router.url}`
        },
        "publisher": {
          "@type": "Organization",
          "name": "Luminous",
          "logo": {
            "@type": "ImageObject",
            "url": ""
          }
        },
        "datePublished": this.formatDate(data?.postingDate)
      };
      BreadcrumbList.push(blogItem);
      this.structuredData = this.sanitizer.bypassSecurityTrustHtml(`
      <script type="application/ld+json">
        ${JSON.stringify(blogItem)}
      </script>
    `);
    // } else { }
  }
  private formatDate(date: string): string {
    if (!date) return '';
    return new Date(date).toISOString().split('T')[0];
  }
  openShareDialog(): void {
    const dialogRef = this.dialog.open(ShareProductModalComponent, {
      disableClose: true,
      maxWidth: '417px',
      width: '100%',
      panelClass: 'productShareModel',
      data: {
        blogGuidId: this.blogID,
        blogUrl: this.blogData && this.blogData.blobUrl ? this.blogData.blogUrl : ''
      }
    });
  }
  goBack(){
    if(isPlatformBrowser(this.platformId)) {  
      window.scrollTo(0, this.scrollPosition);
      this.location.back();
    }
  }
  ngOnDestroy(): void {

    this.sub.unsubscribe()
  }
}
